<script setup>
import { Label } from "radix-vue";
import { cn } from "@/lib/utils";

const props = defineProps({
  class: { type: String, default: "" },
  asChild: { type: Boolean, default: false },
  for: { type: String, default: undefined },
});
</script>

<template>
  <Label
    v-bind="props"
    :class="cn(
      'text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70',
      props.class
    )"
  >
    <slot />
  </Label>
</template>
